import React, { useState, useEffect, createRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import Grid from "@material-ui/core/Grid";
import "./PathologyReport.css";
import avtar from "../../assets/img/report1.png";
import { DirectUpload } from "@rails/activestorage";
import baseUrl from "../../utils/baseUrl";
import "../../components/toast.css";
import { getRequest } from "../../api/Api";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

const styles = theme => ({
  root: {
    padding: "16px",
  },
});
const useStyles = makeStyles(styles);

class Uploader {
  constructor(file, url, index) {
    this.file = file;
    this.url = url;
    this.index = index;
    this.uploadObj = new DirectUpload(this.file, this.url, this);
    this.progressElement = document.getElementById(
      `direct-uploadss-${this.index}`,
    );
    this.progressBar = document.getElementById(
      `direct-uploadss-progress-${this.index}`,
    );
  }

  upload(file) {
    return new Promise((resolve, reject) => {
      this.uploadObj.create((error, blob) => {
        if (error) {
          this.progressElement.classList.add("direct-uploadss--error");
          this.progressElement.setAttribute("title", error);
          reject(error);
        } else {
          this.progressElement.classList.add("direct-uploadss--complete");
          const hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("value", blob.signed_id);
          // hiddenField.id = `pathologydocument_${this.index}`;
          hiddenField.setAttribute("class", `pathologydocument_`);
          document.getElementById("pathalogy").appendChild(hiddenField);
          resolve("Success");
        }
      });
    });
  }

  directUploadDidProgress(event) {
    this.progressBar.style.width = `${(100 * event.loaded) / event.total}%`;
  }

  directUploadWillStoreFileWithXHR(request) {
    this.progressElement.classList.remove("direct-uploadss--pending");
    request.upload.addEventListener("progress", event =>
      this.directUploadDidProgress(event),
    );
  }
}

const PathologyReport = props => {
  const { patientid, visitid, handlePathologyCount } = props;
  const classes = useStyles();
  const [list, setList] = useState([]);
  const [acceptedPathologyData, setAcceptedPathologyData] = useState([]);

  const fetchDocumentTitle = () => {
    const token = "Bearer " + localStorage.getItem("jwt");
    getRequest("get_patient_document_type_list", token).then(data => {
      if (data.error) {
        console.log(data.error);
      } else {
        setList(data[0]);
      }
    });
  };

  useEffect(() => {
    fetchDocumentTitle();
  }, []);

  const fileInput = createRef();
  const addProgressBar = (file, index, handler) => {
    handler.insertAdjacentHTML(
      "afterend",
      `<br/>
     <div id="direct-uploadss-${index}" class="direct-uploadss direct-uploadss--pending">
     <div id="direct-uploadss-progress-${index}" class="direct-uploadss__progress" 
     style="width: 0%"></div>
     <span class=direct-uploadss__filename">${file.name}</span>
     </div>`,
    );
  };

  var pathologyTemp = [];
  const differenceOf2ArraysOfPathology = (array1, array2) => {
    for (var i in array1) {
      if (array2.indexOf(array1[i]) === -1) pathologyTemp.push(array1[i]);
    }
    for (i in array2) {
      if (array1.indexOf(array2[i]) === -1) pathologyTemp.push(array2[i]);
    }
    return pathologyTemp.sort((a, b) => a - b);
  };

  const handlePathologyFile = formData => {
    return new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < fileInput.current.files.length; i++) {
        addProgressBar(fileInput.current.files[i], i, fileInput.current);
        if (fileInput.current.files[i].size <= 10000000) {
          promises.push(uploadFile(fileInput.current.files[i], i));
        } else {
          alert(
            `Your file ${fileInput.current.files[i].name} was not uploaded because it exceeds the 10 MB size limit.`,
          );
        }
      }
      Promise.all(promises)
        .then(() => {
          var patientPathologyDocument = document.getElementsByClassName(
            `pathologydocument_`,
          );
          var pathologyFiles = [];
          for (let i = 0; i < patientPathologyDocument.length; i++) {
            setAcceptedPathologyData(prevAcceptedData => [
              ...prevAcceptedData,
              patientPathologyDocument[i].value,
            ]);
            pathologyFiles.push(patientPathologyDocument[i].value);
          }
          console.log(pathologyFiles);
          console.log(acceptedPathologyData);
          differenceOf2ArraysOfPathology(pathologyFiles, acceptedPathologyData);
          var pathologyReport = [];
          for (let i = 0; i < pathologyTemp.length; i++) {
            pathologyReport.push({
              documents: pathologyTemp[i],
              visit_id: visitid,
              document_type: list.key,
            });
            Object.keys(pathologyReport[i]).forEach(key => {
              formData.append(
                `patient[patient_documents_attributes][${i}][${key}]`,
                pathologyReport[i][key],
              );
            });
          }
        })
        .then(() => resolve("looped through all files!"))
        .catch(error => reject(error));
    });
  };

  const uploadFile = (file, index) => {
    return new Promise((resolve, reject) => {
      const URL = `${baseUrl}/rails/active_storage/direct_uploads`;
      new Uploader(file, URL, index)
        .upload(file)
        .then(message => resolve(message))
        .catch(error => reject(error));
    });
  };

  const handle = event => {
    var formData = new FormData();

    handlePathologyFile(formData)
      .then(message => {
        // console.log(patientid);
        if (
          localStorage.getItem("jwt") !== "" ||
          localStorage.getItem("jwt") !== undefined
        ) {
          let token = "Bearer " + localStorage.getItem("jwt");
          fetch(`${baseUrl}/save_patient_documents/${patientid}`, {
            method: "PUT",
            headers: {
              Authorization: token,
            },
            body: formData,
          }).then(response => {
            response.json().then(data => {
              if (response.status === 200) {
                toast(<p>{data.message}</p>, {
                  className: "custom",
                  autoClose: 1000,
                });
                handlePathologyCount();
              } else {
                toast.error(<p>{data.error}</p>, { autoClose: 3000 });
              }
            });
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  return (
    <div className={classes.root} style={{ marginTop: "-20px" }}>
      <Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card
            style={{
              marginTop: "14px",
              boxShadow:
                "0 2px 8px rgba(0,0,0,0.30), 0 10px 12px rgba(0,0,0,0.22)",
            }}
          >
            <img src={avtar} style={{ height: 165 }} alt="document" />
            <div style={{ textAlign: "center", fontSize: 16, fontWeight: 500 }}>
              <label>Select Pathology Report</label>
            </div>
            <CardBody>
              <form id="pathalogy">
                <Grid item xs={12} sm={12} md={12} container justify="center">
                  <div className="fileUpload">
                  <span style={{ cursor:'pointer' }}>Upload</span>
                    <input
                      type="file"
                      onChange={handle}
                      multiple={true}
                      className="upload"
                      data_cy ="pathology-upload-input"
                      accept=".pdf,.jpg,.jpeg,.png"
                      ref={fileInput}
                    />                   
                  </div>
                </Grid>
                <ToastContainer />
                <br />
              </form>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default PathologyReport;
